import { helper } from '@ember/component/helper'

interface Signature {
  Args: {
    Positional: unknown[]
  }
  Return: ReturnType<typeof window.encodeURIComponent>
}

export const encodeURIComponent = helper<Signature>(function ([toEncode]) {
  if (typeof toEncode === 'string' || typeof toEncode === 'number' || typeof toEncode === 'boolean') {
    return window.encodeURIComponent(toEncode)
  }
  return ''
})

export default encodeURIComponent
